import Input from './input.vue';

Input.install = function(Vue){
    Vue.component(Input.name, Switch);
}

export default Input;



// WEBPACK FOOTER //
// ./src/componnets/input/index.js